import type { PropsWithClassname } from "@/types"
import React from "react"
import { Icon } from "./Icons"
import { Text } from "./Text"
import { TwoStepConfirmButton } from "./TwoStepConfirmButton"

interface DeleteItemButtonProps extends PropsWithClassname {
  onConfirm: () => void
  disabled?: boolean
}

export const DeleteItemButton: React.FC<DeleteItemButtonProps> = ({
  onConfirm,
  disabled = false,
  className,
}) => {
  return (
    <TwoStepConfirmButton
      onConfirm={onConfirm}
      disabled={disabled}
      className={className}
      initialContent={
        <Icon name="trash" className="h-5 w-5 text-outline-800" />
      }
      confirmationContent={
        <Text className="text-outline-800 text-sm">Confirm deletion?</Text>
      }
    />
  )
}
